import { Button as MuiButton } from '@mui/material'
import { ButtonProps } from './Button.types'

/**
 * A thin pass-through to MUI's Button, as in the Planner Portal: every visual
 * decision (height, radius, the teal fill, the outlined default) lives in the
 * theme's `MuiButton` override, never here.
 */
export const Button = ({
  children,
  icon,
  disableRipple = true,
  label,
  color = 'primary',
  ...otherProps
}: ButtonProps) => {
  return (
    <MuiButton
      color={color}
      aria-label={label}
      disableRipple={disableRipple}
      startIcon={icon}
      {...otherProps}
    >
      {children}
    </MuiButton>
  )
}
